import { Link } from "react-router-dom";
import { SITE } from "@/lib/site";

export default function Footer() {
  return (
    <footer className="border-t border-ink" data-testid="site-footer">
      <div className="mx-auto max-w-[1600px] px-5 md:px-8 py-7 grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8 items-start text-sm text-ink/75">
        <div className="md:col-span-3">
          <Link to="/" className="display text-ink text-2xl">{SITE.name}</Link>
          <p className="mt-2">{SITE.location} · {SITE.year}</p>
        </div>

        <nav className="md:col-span-5 flex flex-wrap gap-x-6 gap-y-3" aria-label="Footer navigation">
          <Link to={{ pathname: "/", hash: "#about" }} className="ember-link" data-testid="footer-about">About us</Link>
          <Link to="/privacy" className="ember-link" data-testid="footer-privacy">Privacy</Link>
          <Link to="/terms" className="ember-link" data-testid="footer-terms">Terms</Link>
          <Link to="/questions" className="ember-link">Questions</Link>
        </nav>

        <div className="md:col-span-4 md:text-right flex flex-col md:items-end gap-2">
          <a href={`tel:${SITE.phoneTel}`} className="ember-link" data-testid="footer-phone">{SITE.phoneDisplay}</a>
          <a href={`mailto:${SITE.email}`} className="ember-link" data-testid="footer-email">{SITE.email}</a>
        </div>
      </div>
    </footer>
  );
}
